/**
*  TheTakeProfit.vue of project WeTradeWeb
*  @date 2022/5/27 16:20
*  @author 阿佑[ayooooo@petalmail.com]
*/
<template>
<div class="df-middle" style="line-height: 56px">
  <t class="flex-1 f-bold" path="placeorder_15">Take Profit</t>
  <Switch :checked="!noLimit" @change="toggleLimit" />
</div>
<div v-if="!noLimit" class="bg-background br-lg p-16 c-title">
  <div class="df-middle">
    <t class="flex-1" path="placeorder_43">Percentage</t>
    <TheLimitRangeInput :min="MIN" :value="percent" @change="v => limit(v)" @exceed="exceed" #="{ value }">
      {{value}}%
    </TheLimitRangeInput>
  </div>
  <div class="df-middle mt-8">
    <t path="placeorder_44" class="flex-1">Est. Price</t>
    {{estQuote}}
  </div>
  <p class="c-tip f-sm">
    <t path="placeorder_45">Profit</t>: <money :v="profit" />
    <t path="placeorder_46" class="ml-4">Pips</t>: {{order.takeProfit.value}} pips
    <template v-if="showDistance">
      <t path="placeorder_48" class="ml-4">Est. Dist</t>: {{distance}}
    </template>
  </p>
</div>
</template>

<script lang="ts">
import { showAlert } from '@/components/popup/popup'
import { translate } from '@/i18n'
import Switch from '@/modules/membership/signal/components/Switch.vue'
import TheLimitRangeInput from '@/modules/trade/components/TheLimitRangeInput.vue'
import Order from '@/modules/trade/Order'
import { useOrderLimit } from '@/modules/trade/trade'
import { computed, defineComponent, inject } from 'vue'

const MIN = 10

export default defineComponent({
  name: 'TheTakeProfit',
  components: { TheLimitRangeInput, Switch },
  props: {
    showDistance: Boolean,
  },
  setup () {
    const order = inject('order') as Order
    const { percent, limit, profit, estQuote, distance } = useOrderLimit(order.takeProfit.value)
    const noLimit = computed(() => percent.value === 0)

    const toggleLimit = (state: boolean) => {
      limit(state ? MIN : 0)
    }

    return {
      order,
      MIN,
      profit,
      estQuote,
      noLimit,
      percent,
      distance,
      limit,
      toggleLimit,
      exceed () {
        showAlert(translate('toast_17'))
      },
    }
  },
})
</script>

<style scoped>
</style>
